import { insertElementBefore } from "./elementDOM";
import {FORM_INPUTS} from "./formInputs";

export const createEmailSuggestionElement = (suggestion) => {
    const div = document.createElement('div');
    div.id = 'emailSuggestion';
    div.style = 'position: absolute; z-index: 10; background: #FFEBC2; width: 100%; padding: 0.5rem; border-radius: 0 0 5px 5px; color: #333333; display: flex; align-items: center; justify-content: space-between;';
    div.style.top = `${document.getElementById('email').offsetHeight}px`;
    div.innerHTML =  `<span class="accept-suggestion-tooltip" style="font-weight: 700; cursor: pointer;">${suggestion}</span> <div><img src="https://cdn069.b-cdn.net/assets/images/accept.png" id="acceptSuggestion" class="accept-suggestion-tooltip" alt="check" style="cursor: pointer;"/> <img src="https://cdn069.b-cdn.net/assets/images/close.png" id="cancelSuggestion" alt="close" style="cursor: pointer;"/></div>`

    insertElementBefore(FORM_INPUTS.email.element, div);
    observeSuggestionAction(suggestion);
}

const observeSuggestionAction = (suggestion) => {
    const acceptSuggestionElements = document.querySelectorAll('.accept-suggestion-tooltip');
    const cancelSuggestionElement = document.getElementById('cancelSuggestion');
    const suggestionElement = document.getElementById('emailSuggestion');

    acceptSuggestionElements.forEach(element => {
        element.addEventListener('click', () => {
            FORM_INPUTS.email.element.value = suggestion;
            suggestionElement.remove();
        });
    })

    cancelSuggestionElement.addEventListener('click', () => {
        suggestionElement.remove();
    });

    FORM_INPUTS.email.element.addEventListener('focus', () => {
        suggestionElement.remove();
    });
}